import { addNetworkClosetDefaults } from 'helpers/networkClosets/defaults'
import { addWiredDeviceDefaults } from 'helpers/wiredDevices/defaults'
import { addWireDefaults } from 'helpers/wires/defaults'
import { addDoorControllerDefaults, addDoorDefaults, addPeripheralDefaults } from 'helpers/accessControl/defaults'
import expandDoorControllerModel from 'helpers/accessControl/expandDoorControllerModel'
import map from 'ramda/src/map'
import evolve from 'ramda/src/evolve'
import compose from 'ramda/src/compose'
import partialRight from 'ramda/src/partialRight'

export default function(entities, doorControllerModels, expansionControllerModels) {
  const transformations = {
    doors: { byId: map(addDoorDefaults) },
    doorControllers: { byId: map(compose(addDoorControllerDefaults, partialRight(expandDoorControllerModel, [doorControllerModels, expansionControllerModels]))) },
    networkClosets: { byId: map(addNetworkClosetDefaults) },
    wiredDevices: { byId: map(addWiredDeviceDefaults) },
    wires: { byId: map(addWireDefaults) },
    // handle peripherals together
    auxiliaryInputs: { byId: map(addPeripheralDefaults('auxiliaryInputs')) },
    auxiliaryOutputs: { byId: map(addPeripheralDefaults('auxiliaryOutputs')) },
    contacts: { byId: map(addPeripheralDefaults('contacts')) },
    doorOpeners: { byId: map(addPeripheralDefaults('doorOpeners')) },
    locks: { byId: map(addPeripheralDefaults('locks')) },
    readers: { byId: map(addPeripheralDefaults('readers')) },
    rexs: { byId: map(addPeripheralDefaults('rexs')) },
    tampers: { byId: map(addPeripheralDefaults('tampers')) }
  }

  return Object.assign({}, evolve(transformations, entities))
}



// WEBPACK FOOTER //
// ./src/helpers/projects/expandEntities.js